export const getPhoneNumbersUrl = (workspaceId: string, agentId: string) =>
  `business/workspaces/${workspaceId}/agents/${agentId}/phone_numbers`;

export const getPhoneNumberUrl = (workspaceId: string, agentId: string) =>
  `business/workspaces/${workspaceId}/agents/${agentId}/phone_number`;
